import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'home-sovendus',
  templateUrl: './sovendus.component.html',
  styleUrls: ['./sovendus.component.scss'],
  imports: [TranslocoPipe],
})
export class SovendusComponent {
  public goToSovendus = (): void => {
    window.open('https://www.sovendus.com/directlink/dfc68f93-4ebd-11ec-970a-02000a00521c', '_blank', 'noopener,noreferrer');
  };
}
